<div class="Customers customers-points ui-g">

    <div class="ui-g-12">
      <app-kontable
        #table
        title="{{ 'customerCluster.import' | translate }}"
        [columns]="[
          {field: 'id', title: 'ID'},
          {field: 'name', title: 'common.name'},
          {field: 'description', title: 'common.description'},
          {field: 'cluster_description', title: 'customerCluster.headDescription'},
          {field: 'import_expected_date', title: 'customerCluster.importExpectedDate', type: 'date'},
          {field: 'import_exec_date', title: 'customerCluster.importExecDate', type: 'date'},
          {field: 'record_ret', title: 'customerCluster.recordRet', type: 'number'}
        ]"
        [service]="service"
        (onAdd)="addImport()"
        (onRemove)="deleteImport($event.id)"
        [paginationType]="paginationType"
        [showRecoverButton]="false"
        [showInfoButton]="false"
        [showAddButton]="true"
        [showDeleteButton]="true"
        [showDetailsButton]="false"
        [showEditButton]="false"
        [showReport]="false"
        [additionalRowCommands]="customRow"
      >
      <ng-template #customRow data-testid="customRow" let-row>
        <p-button label="" pTooltip="{{ 'common.details' | translate }}" icon="fa fas fa-eye" styleClass="ui-button-info" (onClick)="openDetailDialog(row)"></p-button>
      </ng-template>
      </app-kontable>
    </div>

</div>

<p-dialog
  class="detail-dialog"
  *ngIf="showDetail"
  [(visible)]="showDetail"
  [modal]="true"
  header="{{ 'customerSetBuilder.importDetail' | translate }} - {{actualRow.name}}"
  [width]="500"
  [minHeight]="150"
  [draggable]="false"
  [responsive]="true"
  [resizable]="false"Import
  (onHide)="closeDetailDialog()">
  <div>
    <ul>
      <li><b>{{'customerSetBuilder.rowRead' | translate }}:</b> {{actualRow.pl_read}}</li>
      <li><b>{{'customerSetBuilder.rowWritten' | translate }}:</b> {{actualRow.pl_write + actualRow.pl_update}}</li>
      <li><b>{{'customerSetBuilder.rowDiscarded' | translate }}:</b> {{actualRow.pl_read - (actualRow.pl_write + actualRow.pl_update)}}</li>
      <li><b>{{'customerSetBuilder.stateImport' | translate }}:</b> {{actualRow.pl_stato_job}}</li>
    </ul>
  </div>
  <div *ngIf="actualRow.pl_flg_state === 'E' " class="padd-top">
    <b>{{'common.error' | translate }}: </b> <br>
    <p class="error">{{actualRow.pl_error}}</p>
  </div>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-import/customer-set-import.component.html